<script>
  import DatePicker from "@shared/svelte/Components/DatePicker.svelte";
  import moment from "moment";

  export let startDate;
  export let endDate;
  export let refreshState;

  let currentFilterDate = null;
  let predefinedRanges = [30, 60, 90];

  const matchDaysBack = daysBack => {
    return (
      startDate == moment(new Date()).subtract(daysBack, "days").format("MM/DD/YYYY") &&
      endDate == moment(new Date()).format("MM/DD/YYYY")
    );
  };

  const predefinedRangeDateMatch = () => {
    predefinedRanges.forEach(
      dateRange => matchDaysBack(dateRange) && (currentFilterDate = dateRange)
    );
  };
  predefinedRangeDateMatch();

</script>

<div class="fizz-flex-row">
  <DatePicker
    bind:startDate
    bind:endDate
    defaultButtonLabel={"Order Dates"}
    runFilters={refreshState}
    alignmentOptions={{
      desktop: { xPosition: "left" },
      mobile: { xPosition: "left" },
    }}
    {predefinedRanges}
    {currentFilterDate}
  />
</div>
